import i18n from '@/plugins/I18n';
import { differenceInYears } from 'date-fns';
import BaseModel from '../../base';

import constants, { STATUS_KEY } from './constants';
import glossary, { STATUS_DATA } from './glossary';

import { I18N_KEY } from '@/constants/I18n';

export default class ClubMember extends BaseModel {
  constructor(item = {}, url) {
    super(item, url);

    this.first_name = item.first_name;
    this.last_name = item.last_name;
    this.middle_name = item.middle_name;

    this.status = item.status || STATUS_KEY.request;

    this.birthday_at = item.birthday_at;

    this.avatar = item.avatar;

    const { last_name, first_name, middle_name } = item || {};
    this.name = [last_name, first_name, middle_name].join(' ') || 'Пользователь не указал ФИО';
  }

  get statusData() {
    const { status } = this;
    const data = STATUS_DATA[this.status];
    return {
      ...data,
      isRequest: status === STATUS_KEY.request,
      isConfirm: status === STATUS_KEY.confirm,
      isReject: status === STATUS_KEY.reject,
    };
  }

  get age() {
    const { birthday_at } = this;
    if (!birthday_at) {
      return '';
    }
    return differenceInYears(new Date(), new Date(birthday_at)) || '';
  }

  get ageText() {
    const { age } = this;
    if (!age) return 'Не указан возраст';
    return i18n.tc(I18N_KEY.years, Number(age));
  }

  static get constants() {
    return constants;
  }

  static get glossary() {
    return glossary;
  }
}
